module.exports = __webpack_public_path__ + "static/media/wheel.c11a7847.png";


//////////////////
// WEBPACK FOOTER
// ./src/wheel.png
// module id = 476
// module chunks = 0